import type { SwellsTimestep } from 'types/swell';
import type { WaveEnergyTimestep } from 'types/waveEnergy';

export function getEnergyKjFromTooltipDatum(
  data: SwellsTimestep | WaveEnergyTimestep | null | undefined,
): number | undefined {
  if (!data) return undefined;
  if ('nearshore' in data && typeof (data as WaveEnergyTimestep).nearshore === 'number') {
    return (data as WaveEnergyTimestep).nearshore;
  }
  if ('power' in data && typeof (data as SwellsTimestep).power === 'number') {
    return (data as SwellsTimestep).power;
  }
  return undefined;
}
